import {Entity} from './main.entity';
import {plainToInstance} from 'class-transformer';
import {SwitchItem} from '../entities/switch.entity';
import fa from "@mobiscroll/angular/dist/js/i18n/fa";
import { AccountableType } from "app/entities/accountableType.entity";

export class EntityCollection<T extends Entity> {
  _items: T[] = [];
  entityType: new() => T;

  set items(items) {
    this._items = items;
  }

  get items() {
    return this._items;
  }

  constructor(
    items: T[],
    entityType: new() => T
  ) {
    this.entityType = entityType;
    this.items = plainToInstance(entityType, items) as unknown as T[];
  }

  addItems(items: (Partial<SwitchItem>)[] = []) {
    const instances = plainToInstance(this.entityType, items) as unknown as T[];
    this.items.push(...plainToInstance(this.entityType, items) as unknown as T[]);
  }

  getByField(field: string, value: string | number): T {
    return this.items.find((item) => (typeof item[field] !== 'undefined' && item[field] !== null) && item[field].toString() === value.toString());
  }

  getById(id: number | string): T {
    return this.getByField('id', id);
  }

  replaceItemByField(value: number | string, field: string = 'id', replaceItem: T) {
    const index = this.items.findIndex((item) => (item[field].toString() === value.toString()));

    if (index > -1) {
      this.items[index] = replaceItem;
    }
  }

  removeByField(field: string, value: string | number) {
    const index = this.items.findIndex(item => item[field].toString() === value.toString());
    if (index > -1) {
      this.items.splice(index, 1);
    }
  }

  removeById(id: string | number) {
    this.removeByField('id', id);
  }

  replaceItemById(id: number, replaceItem: T) {
    return this.replaceItemByField(id, 'id', replaceItem);
  }

  getFields(fieldKey: string) {
    return this.items.map((item) => item[fieldKey]);
  }

  getIds() {
    return this.getFields('id');
  }
}
